import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel , MdPreview} from 'react-icons/md';
import { BsFillSendFill } from "react-icons/bs";
import { TiCancel } from "react-icons/ti";
import { FaTrash } from "react-icons/fa";
import { IoMdCheckmark } from 'react-icons/io';
import { Layout, Header } from '../../../../components';
import { handleApi, formatCurrency, formatTwoDecimal, formatMediumDate } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ApproveInvoice = () => {
  const location = useLocation();
  const { inv } = location.state || {};
  console.log('invoice',inv)
  const [invoice, setInvoice] = useState(() => {
    const initialTransactionLines = inv?.transactionLines?.length > 0
      ? inv.transactionLines.map((line) => ({
          id: line.id || null,
          product_id: line.product_id || null,
          product_name: line.name || '',
          description: line.description || line.name || '',
          unit_price: line.unit_price || 0,
          discount_percentage: line.discount_percentage || 0,
          quantity: line.quantity || 1,
          total: (line.unit_price || 0) * (line.quantity || 1)
        }))
      : [{
          id: null,
          product_id: null,
          product_name: '',
          description: '',
          unit_price: 0,
          discount_percentage: 0,
          quantity: 1,
          total: 0
        }];
    
    return {
      date: inv?.date || new Date().toISOString().split('T')[0],
      due_date: inv?.due_date || new Date().toISOString().split('T')[0],
      id: inv?.id || '',
      partner_id: inv?.partner_id || '',
      state: inv?.state || 'draft',
      transactionLines: initialTransactionLines,
    };
  });

  const [isLoading, setIsLoading] = useState(false);
  const [showApproveButton, setShowApproveButton] = useState(true); // Track button visibility
  const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
  const navigate = useNavigate();

  // Timeout helper for API calls
  const handleApiWithTimeout = async (url, data, userData, method, parameters, timeout = 5000) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await handleApi(url, data, userData, method, parameters, { signal: controller.signal });
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        toast.error('Request timed out');
      } else {
        toast.error('Error: ' + error.message);
      }
      throw error;
    } finally {
      clearTimeout(timeoutId);
    }
  };

  const handleSubmit = async () => {
    console.log('ready for submission sir ',invoice)
    const cleanedInvoice ={  id:invoice.id,state:  'invoice_approved'}
    const apiEndpoint='purchase/invoices'
    const apiMethod='PUT'
    const parameters={};
    // const parameters={id:invoice.id};
    setIsLoading(true); // Start loading
    try {
      const response = await handleApiWithTimeout(apiEndpoint, cleanedInvoice, userData, apiMethod, parameters);
      console.log("API Response:", response);  // Log the API response to see if we are getting the expected data
      if (response.status === 200) {
        toast.success('Purchase Invoice approved successfully.');
        setShowApproveButton(false);
      } else {toast.error('Error approving purchase Invoice.', response.statusText); }
    } catch (error) {
      console.error("API Error:", error);  // Log any error that might occur
      toast.error('Error approving purchase Invoice: ' + error.message);
    } finally {
      setIsLoading(false); // Always stop loading after request is done
      setActionCount(actionCount + 1); // Update action count
    }
  };


  const handleClose = () => { navigate(-1);};

  // Calculate subtotal, tax, and discount
  const subtotal = inv?.totalUntaxedPrice || 0;


  const discountAmount = inv?.totalDiscount || 0;
  const subtotalAfterDiscount = subtotal - discountAmount;
  const taxAmount = inv?.totalTax || 0;;
  const grandTotal = subtotalAfterDiscount + taxAmount;

  // Format the values
  const formattedSubtotal = formatCurrency(subtotal.toFixed(2));
  const formattedDiscount = formatCurrency(discountAmount.toFixed(2));
  const formattedSubtotalAfterDiscount = formatCurrency(subtotalAfterDiscount.toFixed(2));
  const formattedTax = formatCurrency(taxAmount.toFixed(2));
  const formattedGrandTotal = formatCurrency(grandTotal.toFixed(2));
  console.log('inv sir',inv)
  const TransactionLineHeader = () => {
    return (
      <div className="grid grid-cols-6 gap-4 p-2 border-b rounded-lg w-full bg-gray-100 text-gray-800 font-semibold">
        <div className="col-span-2 text-left">Product Description</div>
        <div className="col-span-1 text-center">Price</div>
        <div className="col-span-1 text-center">Quantity</div>
        <div className="col-span-1 text-center">Discount %</div>
        <div className="col-span-1 text-right">Total</div>
      </div>
    );
  };
  console.log('invoice date sir ',invoice.due_date)

  return (
    <Layout>
      <div className="m-4 bg-white rounded-3xl shadow-lg">
        <ToastContainer position="top-center" autoClose={2000} />
        
        {/* Header with buttons */}
        <div className="text-center py-4 border-b">
          <div className="w-full flex justify-end">
            <button className="text-gray-600 hover:text-gray-900 py-1 px-2 rounded transition-all duration-300" title="Close" onClick={handleClose}>
              <MdOutlineCancel size={24} color={currentColor} />
            </button>
          </div>

            <div className="flex justify-center flex-grow">
              <Header category="Purchase" title="Approve Invoice" color={currentColor}/>
          </div>
        </div>

        <div className="flex justify-between items-center border-b px-6">
                  <div className="flex items-center space-x-6">
                    {/* Enhanced Circle Logo with Glow Effect */}
                    <div className="flex justify-center items-center w-18 h-18 bg-gradient-to-r from-indigo-600 via-blue-500 to-purple-600 text-white text-4xl font-semibold rounded-full shadow-xl transform hover:scale-110 transition-all hover:bg-gradient-to-r hover:from-blue-500 hover:to-teal-500">
                      {inv?.partners?.name ? inv.partners.name.split(' ').map(word => word[0].toUpperCase()).join('') : 'NA'}
                    </div>
                    <div>
                      <h1 className="text-4xl font-bold text-gray-800 tracking-wide">Invoice</h1>
                      <p className="text-lg text-gray-600 mt-1 font-semibold">Issued by: {inv?.partners?.name.toUpperCase() || 'NA' }</p>
                    </div>
                  </div>
                  <div className="text-right font-semibold">
                    <p className="text-xl text-gray-700">Invoice # {inv?.invoice_no || 'NA'}</p>
                    <p className="text-md text-gray-500">Issued: {formatMediumDate(invoice?.date) || 'NA'}</p>
                    <p className="text-md text-gray-500">Due: {formatMediumDate(invoice?.due_date) || 'NA'}</p>
                  </div>
                </div>

        {/* Loading State */}
        {isLoading ? (
          <div className="flex flex-col items-center py-6">
            <Audio height="80" width="80" radius="9" color={currentColor} ariaLabel="three-dots-loading" />
            <p className="mt-4 text-gray-600">Loading. Please wait...</p>
          </div>
        ) : (
            
          <div className="bg-gray-50 p-4 my-8 rounded-lg max-w-4xl mx-auto shadow-md">
            <div className="flex justify-end  pb-2">
            {showApproveButton && (
              <button
                onClick={handleSubmit}
                className=" text-white px-6 py-2 mb-2 rounded-lg flex items-center justify-center space-x-2"
                style={{ backgroundColor: "green" }}
              >
                <IoMdCheckmark  size={25}/>
                <span>Approve</span>
              </button>
            )}
            </div>
            
          
            {/* Supplier Info Section */}
            <div className="flex flex-col md:flex-row mb-6 space-y-4 md:space-y-0 md:space-x-6">
              <div className="bg-white p-4 rounded-lg shadow-md w-full md:w-1/2">
                <p className="text-lg font-semibold text-gray-800 text-center mb-4 uppercase">Supplier Info</p>
                <div className="space-y-3">
                  {[
                 
                    { label: "Telephone", value: inv?.partners?.phone_number || 'NA' },
                    { label: "Contact Person", value: inv?.partners?.contact_person || 'NA' },
                  ].map((item, index) => (
                    <div key={index} className="flex justify-between text-sm text-gray-700">
                      <label className="font-medium">{item.label}</label>
                      <span className="text-gray-500">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Quotation Info Section */}
              <div className="bg-white p-4 rounded-lg shadow-md w-full md:w-1/2">
                <p className="text-lg font-semibold text-gray-800 text-center mb-4 uppercase">Invoice Info</p>
                <div className="space-y-3">
                  {[
                    { label: "Internal Reference #", value: inv?.reference || 'NA' },
                    { label: "STATUS", value: (invoice?.state || 'NA').toUpperCase() }, // Capitalize first letter of status

                  ].map((item, index) => (
                    <div key={index} className="flex justify-between text-sm text-gray-700">
                      <label className="font-medium">{item.label}</label>
                      <span className="text-gray-500">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            

             {/* Transaction lines */}
                        <div className="bg-white rounded-lg shadow-md">
                          {invoice.transactionLines?.length > 0 ? (
                            <>
                              <TransactionLineHeader />
            {invoice.transactionLines.map((line, index) => (
              <div
                key={index}
                className={`grid grid-cols-6 p-3 border-b hover:bg-gray-100 ${index === invoice.transactionLines.length - 1 ? 'border-b' : ''}`}
              >
                <div className="col-span-2 text-gray-700">{line.description || ''}</div>
                <div className="col-span-1 text-center text-gray-600">{formatTwoDecimal(line.unit_price) || ''}</div>
                <div className="col-span-1 text-center text-gray-600">{line.quantity || ''}</div>
                <div className="col-span-1 text-center text-gray-600">{line.discount_percentage || 0}</div>
                <div className="col-span-1 text-right text-gray-600">{formatTwoDecimal(line.total) || ''}</div>
              </div>
            ))}
            {/* end transation */}
            
                              <div className="bg-white p-6 rounded-lg shadow-md mt-3">
              <div className="font-semibold text-lg text-gray-800 mb-2">Invoice Summary</div>
            
              {/* Subtotal Section */}
              <div className="flex justify-between items-center border-b py-3 text-gray-800">
                <div className="text-sm">Subtotal:</div>
                <div className="text-sm font-semibold">{formattedSubtotal}</div>
              </div>
            
              {/* Discount Section */}
              <div className="flex justify-between items-center border-b py-3 text-gray-800">
                <div className="text-sm">Discount:</div>
                <div className="text-sm font-semibold text-red-500">- {formattedDiscount}</div>
              </div>
            
              {/* Subtotal After Discount Section */}
              <div className="flex justify-between items-center border-b py-3 text-gray-800">
                <div className="text-sm">Subtotal After Discount:</div>
                <div className="text-sm font-semibold">{formattedSubtotalAfterDiscount}</div>
              </div>
            
              {/* Tax Section */}
              <div className="flex justify-between items-center py-3 text-gray-800">
                <div className="text-sm">Tax:</div>
                <div className="text-sm font-semibold">{formattedTax}</div>
              </div>
            
              {/* Grand Total Section */}
              <div className="flex justify-between items-center py-3 font-semibold text-lg text-gray-900 border-t mt-4">
                <div className="text-sm">Grand Total:</div>
                <div className="text-sm">{formattedGrandTotal}</div>
              </div>
            </div>
                </>
              ) : (
                <p className="p-6 text-center text-gray-500">No transactions found. Please ensure the selected invoice has transactions.</p>
              )}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ApproveInvoice;
